import {
    SET_VIEWING_RESULT,
    SessionActionTypes,
    SET_SELECTED_COLLECTION,
    SET_WAREHOUSE_CREATED,
    SET_SESSIONS_CHANGE,
    SET_DISPLAY_SESSION_SIDEBAR,
    SET_SELECTED_SESSION,
} from './types';

import SwabComponentModel from '../models/SwabComponentModel';
import SessionModel from '../models/SessionModel';

export function setViewingResult(result: SwabComponentModel): SessionActionTypes {
    return {
        type: SET_VIEWING_RESULT,
        payload: result,
    };
}

export function setSelectedCollection(collectionID: number): SessionActionTypes {
    return {
        type: SET_SELECTED_COLLECTION,
        payload: collectionID,
    };
}

export function setWarehouseCreated(created: boolean): SessionActionTypes {
    return {
        type: SET_WAREHOUSE_CREATED,
        payload: created,
    };
}

export function setSessionsChange(change: boolean): SessionActionTypes {
    return {
        type: SET_SESSIONS_CHANGE,
        payload: change,
    };
}

export function setDisplaySessionSidebar(displaySidebar: boolean): SessionActionTypes {
    return {
        type: SET_DISPLAY_SESSION_SIDEBAR,
        payload: displaySidebar,
    };
}

export function setSelectedSession(session: SessionModel): SessionActionTypes {
    return {
        type: SET_SELECTED_SESSION,
        payload: session,
    };
}
